// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "common" + "." + "9e94f5c4ffe59662bdbe" + ".css";
};